import React, { useState, useContext, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { Helmet } from 'react-helmet';
import NProgress from 'nprogress';

const Login = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [password, setPassword] = useState('');
  const { login, isAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();

  // Redirect if already logged in
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    NProgress.start();
    
    // Simple validation
    if (!phoneNumber || !password) {
      alert('Telefon belgini we açar sözi giriziň');
      NProgress.done();
      return;
    }
    
    // Only numbers validation for phone
    if (!/^\d+$/.test(phoneNumber)) {
      alert('Telefon belgisi diňe sanlardan ybarat bolmaly');
      NProgress.done();
      return;
    }
    
    const success = await login(phoneNumber, password);
    if (success) {
      navigate('/');
    }
    NProgress.done();
  };

  return (
    <>
      <Helmet>
        <title>Girmek - SMS Serwis</title>
      </Helmet>
      
      <div className="min-h-screen flex items-center justify-center bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8 bg-white p-8 rounded-lg shadow-md">
          <div>
            <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
              SMS Serwis - Giriş
            </h2>
            <p className="mt-2 text-center text-sm text-gray-600">
              ýa-da{' '}
              <Link to="/register" className="font-medium text-indigo-600 hover:text-indigo-500">
                täze hasap döretmek
              </Link>
            </p>
          </div>
          <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
            <div className="rounded-md shadow-sm -space-y-px">
              <div>
                <label htmlFor="phone-number" className="sr-only">
                  Telefon belgiňiz:
                </label>
                <input
                  id="phone-number"
                  name="phoneNumber"
                  type="text"
                  autoComplete="tel"
                  required
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                  placeholder="Telefon belgiňiz (meselem: 64279765)"
                />
              </div>
              <div>
                <label htmlFor="password" className="sr-only">
                  Açar söziňiz
                </label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                  placeholder="Açar söziňiz"
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Ulgama girmek
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Login;